var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container iost-404"},[_c('div',{staticClass:"dialog"},[_c('h1',[_vm._v("Whoops!")]),_vm._v(" "),_c('p',[_vm._v("We were unable to find the page you were looking for")])]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":"/static/img/404.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d6bfd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404/index.vue
// module id = jNb6
// module chunks = 2